/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import Uppy from '@uppy/core';
import swal from 'sweetalert';
import { DragDrop, ProgressBar, StatusBar } from '@uppy/react';
import AwsS3Multipart from '@uppy/aws-s3-multipart'
import '@uppy/core/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import '@uppy/status-bar/dist/style.css';

import { loadState } from '../../../store/sessionStore'
import { httpDelete,httpGet,httpPost,httpPut } from '../../../store/externalCalls/httpCalls'
export const generateRandomString = (length) => { 
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getHeaders = () => {
  const { apiToken } = loadState();
  const header = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (apiToken !== undefined) {
    header.Authorization = `Bearer ${apiToken}`;
  }
  return header;
};

class UploadGCSDragAndDrop extends React.Component {

  constructor(props) {
    super(props);
    this.state = { enableDragAndDrop: true, numberOfUploads: 0 };

    this.showError = (error) => {
      const message = error.message ? error.message : 'This file can not be uploaded!';
      swal('Error', message, 'error');
    };
    this.greatestCommonDivisor = (a, b) => {
      return (b == 0) ? a : this.greatestCommonDivisor(b, a%b);
    }
    this.uppy = Uppy({
      autoProceed: true,
      debug:true,
      allowMultipleUploads: true,
      restrictions: {
        maxNumberOfFiles: this.props.numberOfFiles,
        allowedFileTypes: this.props.fileType,
      },
      onBeforeFileAdded: (currentFile, files) => {
        const extension = currentFile.name.split('.')[1]
        const finalName = generateRandomString(50)+'.'+extension
        
        const modifiedFile = {
          ...currentFile,
          name: finalName,
        };

        return modifiedFile;
      },
    }).use(AwsS3Multipart, {

      companionUrl: process.env.REACT_APP_BACKEND_URL+process.env.REACT_APP_API_ENDPOINT,
      createMultipartUpload(file) {
        console.log("Creating Multipart")

        return httpPost('gcs/multipart',{
          filename: encodeURIComponent(file.name),
          type: file.type  
        })
      },

      prepareUploadPart(file,partData) {
        console.log("Signed Part:",partData.uploadId,partData.key)
      
        return httpGet(`gcs/multipart/${partData.uploadId}/${partData.number}/${encodeURIComponent(file.name)}`).then(res=>{
          return res
        })
    
      },
      abortMultipartUpload(file, {uploadId,key}) {
        console.log("abort MUltipart", uploadId)
        return  httpDelete(`gcs/multipart/${uploadId}/${key}`)
      
      },
    
      completeMultipartUpload(file, {uploadId,key,parts}){
        return httpPost(`gcs/multipart/${uploadId}/complete`,{
          filename:file.name,
          key:key,
          parts:parts
        })
      
      },
      listParts (file,partData) {
       
        console.log("List parts")
        const filename = encodeURIComponent(partData.key)
        const response = httpGet(`/gcs/multipart/${partData.uploadId}?key=${file.filename}`)
    
        return response.json()
      },
      
    }).on('complete', (result) => {
      console.log("complete ✅", result)
      const oldState = this.state;
      oldState.numberOfUploads -= 1;
      if (oldState.numberOfUploads <= 0) {
        oldState.numberOfUploads = 0;
        this.props.onCompleted(result);
        this.setState({ ...oldState, enableDragAndDrop: this.props.enableManyTimes });
      } else {
        this.setState({ ...oldState });
      }
    })
    this.uppy.on('file-added', (file) => {

      if(props.imageHeight || props.imageWidth){
        const data = file.data // is a Blob instance
        const url = URL.createObjectURL(data)
        const image = new Image()
        image.src = url
        image.onload = () => {
          if(props.imageHeight && (image.height !== props.imageHeight) || props.imageWidth && (image.width !==props.imageWidth)){
            let error=[];
            if(props.imageHeight && (image.height !== props.imageHeight)){
              error.push("height: " + props.imageHeight);
            }
            if(props.imageWidth && (image.width !== props.imageWidth)){
              error.push("width: " + props.imageWidth);
            }
            let messageStr="The image should be of "+ error.join(" and ");
            this.showError({message:messageStr});
            this.uppy.cancelAll();
          }
          this.uppy.setFileMeta(file.id, { width: image.width, height: image.height })
          URL.revokeObjectURL(url)
        }
      }
      if(props.aspectRatio){
        const data = file.data // is a Blob instance
        const url = URL.createObjectURL(data)
        const image = new Image()
        image.src = url
        image.onload = () => {
          let gcd = this.greatestCommonDivisor(image.width,image.height);
          let imageAspectRatio = (image.width/gcd) + ':' + (image.height/gcd);
          if( imageAspectRatio !== props.aspectRatio ){
            this.showError({message:'The file should be of aspect ratio ' + props.aspectRatio});
            this.uppy.cancelAll();
          }
          if(props.imageHeight && props.imageWidth && (image.width !== props.imageWidth) && (image.height !== props.imageHeight)){
            this.showError({message:'The image should be of height: ' + props.imageHeight + ' and width: ' + props.imageWidth});
            this.uppy.cancelAll();
          }
          this.uppy.setFileMeta(file.id, { width: image.width, height: image.height })
          URL.revokeObjectURL(url)
        }
        
      }      

    });
    
    this.uppy.on('cancel-all', (result) => {
      const oldState = this.state;
      oldState.numberOfUploads = 0;
      this.setState({ ...oldState });
      this.props.onCanceled(result);
    });

    this.uppy.on('upload-error', (file, error) => {
      this.showError(error);
      this.props.onError(file, error);
    });

    this.uppy.on('error', (error) => {
      this.showError(error);
    });

    this.uppy.on('restriction-failed', (file, error) => {
      this.showError(error);
    });

    this.uppy.on('upload', (result) => {

      const oldState = this.state;

      if (oldState.numberOfUploads === 0) {
        this.props.onUpload(result);
      }
      oldState.numberOfUploads += 1;
      this.setState({ ...oldState });
    });


    this.uppy.on('upload-success', (file, result) => {
      
      const videoData = {
        filename: file.name,
        contentType: file.type,    
      }
      httpPost(`signed-url/gcs`,videoData).then(res=>{
        this.props.onUploaded(file, result,{...res,videoData});
      })

    });

    this.removeBackgroundFile = (fileId) => {
      this.uppy.removeFile(fileId);
    };
  }

  componentWillUnmount() {
    this.uppy.close();
  }

  render() {
    return (
      <div {...(this.props.id && this.props.id != '' ? { id: this.props.id } : {})} className={this.props.className}>
        {this.state.enableDragAndDrop === true
        && (
        <DragDrop
          uppy={this.uppy}
          locale={{
            strings: {
              // Text to show on the droppable area.
              // `%{browse}` is replaced with a link that opens the system file selection dialog.
              dropHereOr: 'Drop here or %{browse}',
              // Used as the label for the link that opens the system file selection dialog.
              browse: 'browse',
            },
          }}
        />
        )}

        <ProgressBar uppy={this.uppy} />
        <StatusBar uppy={this.uppy} />
      </div>
    );
  }
}

UploadGCSDragAndDrop.propTypes = {
  /**
   * id of upload async
   */
  id: PropTypes.string,
  /**
   * Completed event function
   */
  onCompleted: PropTypes.func,
  /**
   * Error event function
   */
  onError: PropTypes.func,
  /**
   * Fired when upload starts.
   */
  onUpload: PropTypes.func,
  /**
   * Fired when a file was loaded
   */
  onUploaded: PropTypes.func,
  /**
   * Fierd when all uploads are caceled
   */
  onCanceled: PropTypes.func,
  /**
   * Format of the accepted files
   */
  fileType: PropTypes.arrayOf((PropTypes.string)),
  /**
   * Number of files accepted
   */
  numberOfFiles: PropTypes.number,
  /**
   * Allow upload many times
   */
  enableManyTimes: PropTypes.bool,
  /**
   * Custom Class
   */
  className: PropTypes.string,
};

UploadGCSDragAndDrop.defaultProps = {
  id: '',
  onCompleted: () => {},
  onError: () => {},
  onUpload: () => {},
  onUploaded: () => {},
  onCanceled: () => {},
  fileType: '',
  numberOfFiles: 1,
  enableManyTimes: false,
  className: '',
};

export default UploadGCSDragAndDrop;
